/* eslint-disable jsx-a11y/anchor-is-valid */
import {redirectLoginMicrosoft} from '../../services/microsoft.service'
export function LoginFormMicrosoft() {
  const getUrlSoFood = async () => {
    window.location.href = redirectLoginMicrosoft
  }

  return (
    <div className='form w-100'>
      <div className='text-center mb-11'>
        <h2 className='text-dark fw-bolder mb-3'>
          En Sodexo, juntos construimos un mejor lugar para trabajar
        </h2>
      </div>
      <div className='d-grid mb-10'>
        <button id='kt_sign_in_submit' className='btn btn-primary' onClick={getUrlSoFood}>
          <span className='indicator-label'>Iniciar sesión con Microsoft</span>
        </button>
      </div>
    </div>
  )
}
